import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { RouteService } from './route.service';

@Injectable()
export class RouterGuard implements CanActivate {
	constructor(private routesService: RouteService) {
	}
	canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
		return this.routesService.validarRuta(route);
	}

}
